export class OrganisationWorkflow {
    taskId: string;
    extOrganisationId: string;
    userId: string;
    organisationStatusCode: string;
    comment: string;
    roleCode: string;
}




// WEBPACK FOOTER //
// ./src/app/models/organisationWorkflow.ts